<script setup lang="ts">
definePageMeta({
  alias: ['/restaurantes'],
  pageType: 'RESTAURANT_SEARCH_COUNTRY',
})
</script>

<template>
  <RestaurantView />
</template>
